import { IValidatePasswordRecoveryCodeDTO } from 'modules/authentication/domain/dtos';
import IValidatePasswordRecoveryCodeRepository from 'modules/authentication/domain/repositories/IValidatePasswordRecoveryCodeRepository';
export default class ValidateVerificationCodeUseCase {
  constructor(
    private validateVerificationCodeRepository: IValidatePasswordRecoveryCodeRepository,
  ) {}

  public async execute(params: IValidatePasswordRecoveryCodeDTO) {
    return this.validateVerificationCodeRepository.validate(params);
  }
}
